const ITEMS = [
  "STUD BOLTS",
  "HEX BOLTS",
  "NUTS",
  "COUNTERSUNK BOLTS",
  "CUSTOMISED ENGINEERING SOLUTIONS",
];

const HexDot = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" className="shrink-0">
    <polygon
      points="5,0 9.3,2.5 9.3,7.5 5,10 0.7,7.5 0.7,2.5"
      fill="none"
      stroke="#6C93C9"
      strokeWidth="1.4"
    />
  </svg>
);

export default function Marquee() {
  return (
    <div
      className="bg-ink border-y border-slate-800 py-4 overflow-hidden"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0">
            {ITEMS.map((t) => (
              <span
                key={t}
                className="flex items-center font-sans font-medium text-[11px] sm:text-xs tracking-[0.14em] uppercase text-slate-300"
              >
                <span className="px-7">{t}</span>
                <HexDot />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
